// client/src/pages/BlogPostPage.jsx

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const BlogPostPage = () => {
    const { slug } = useParams();
    const [post, setPost] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchPost = async () => {
            try {
                const response = await axios.get(`/api/pages/blog/${slug}`);
                setPost(response.data);
            } catch (error) {
                console.error("Error fetching blog post:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchPost();
    }, [slug]);

    if (isLoading) return <p>Loading...</p>;

    if (!post) return <p>Blog post not found.</p>;

    return (
        <div className="blog-post-container py-6">

            <h1 className="text-3xl font-bold">{post.title}</h1>
            <p className="text-gray-600 text-sm">By {post.author}</p>
            <div className="blog-post-content mt-4">
                {post.content.map((section, index) => {
                    switch (section.type) {
                        case "text":
                            return <p key={index}>{section.content}</p>;
                        case "image":
                            return (
                                <img
                                    key={index}
                                    src={section.src}
                                    alt={section.alt}
                                    className="my-4"
                                />
                            );
                        case "quote":
                            return (
                                <blockquote
                                    key={index}
                                    className="italic text-gray-600 my-4"
                                >
                                    {section.content}
                                </blockquote>
                            );
                        case "list":
                            return (
                                <ul key={index} className="list-disc pl-5 my-4">
                                    {section.items.map((item, idx) => (
                                        <li key={idx}>{item}</li>
                                    ))}
                                </ul>
                            );
                        default:
                            return null;
                    }
                })}
            </div>
            <p className="text-blue-600 text-sm">
                Permalink:{" "}
                <a href={`/blog/${post.slug}`} target="_blank" rel="noopener noreferrer">
                    {`/blog/${post.slug}`}
                </a>
            </p>
        </div>
    );
};

export default BlogPostPage;
